import { render, staticRenderFns } from "./fork_suggestion_modal.vue?vue&type=template&id=2ea7f6e4&vue3"
import script from "./fork_suggestion_modal.vue?vue&type=script&lang=js&vue3"
export * from "./fork_suggestion_modal.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports